import { render, staticRenderFns } from "./DSCountrySelect.vue?vue&type=template&id=6d8c7076&"
import script from "./DSCountrySelect.vue?vue&type=script&lang=js&"
export * from "./DSCountrySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports